module.exports = __webpack_public_path__ + "img/case54-jpg.397a4647.jpg";